export const SUPPORTED_LOCALES = ["en", "es", "it", "fr", "de", "pt"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "en";

export function isLocale(s: string): s is Locale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(s);
}

/** Build a locale-aware path. English uses bare path, others get /:locale prefix. */
export function localePath(locale: Locale, path: string = "/"): string {
  const clean = path.startsWith("/") ? path : `/${path}`;
  if (locale === "en") return clean;
  return `/${locale}${clean === "/" ? "" : clean}`;
}

/** Regex to detect and strip a locale prefix from a path. Derived from SUPPORTED_LOCALES (minus "en"). */
const NON_EN = SUPPORTED_LOCALES.filter((l) => l !== "en").join("|");
export const LOCALE_REGEX = new RegExp(`^\\/(${NON_EN})(\\/|$)`);

/** Strip locale prefix from a pathname, returning the bare path. */
export function stripLocale(pathname: string): string {
  return pathname.replace(LOCALE_REGEX, "/").replace(/\/+$/, "") || "/";
}

export const LOCALE_LABELS: Record<Locale, string> = {
  en: "English",
  es: "Español",
  it: "Italiano",
  fr: "Français",
  de: "Deutsch",
  pt: "Português",
};
